var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBdcdd5A2A73E4B0E9334081F5E61C648(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.702,
    height: 36,
    viewBox: "0 0 28.702 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bdcdd5a2a73e4b0e9334081f5e61c648",
    d: "M22.869,36.125a8.62,8.62,0,0,1-3.054-.734,6.884,6.884,0,0,0-2.318-.6,6.807,6.807,0,0,0-2.172.568,9.2,9.2,0,0,1-3.186.752c-1.916,0-3.633-1.1-5.258-3.348-.068-.1-6.683-9.81-3.47-17.023,1.76-3.95,4.3-5.955,7.536-5.955a14.1,14.1,0,0,1,4.555.969,7.491,7.491,0,0,0,1.732.468,6.542,6.542,0,0,0,1.792-.506,12.35,12.35,0,0,1,4.326-.973c2.439,0,4.646,1.126,6.75,3.442a.758.758,0,0,1-.115,1.122c-2.218,1.616-3.342,3.485-3.342,5.557,0,2.566,1.267,4.452,4.23,6.3a.753.753,0,0,1,.291.952C28.38,33.342,25.822,36.125,22.869,36.125ZM17.306,9.35a4.687,4.687,0,0,1-.546-.033.753.753,0,0,1-.664-.723A8.328,8.328,0,0,1,23.372.128a.765.765,0,0,1,.817.62,7.293,7.293,0,0,1-1.8,5.887A6.954,6.954,0,0,1,17.306,9.35Z",
    transform: "translate(-2.531 -0.125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdcdd5A2A73E4B0E9334081F5E61C648);
export default __webpack_public_path__ + "static/media/bdcdd5a2a73e4b0e9334081f5e61c648.874d559d6c61574fd8c458b6f671fba2.svg";
export { ForwardRef as ReactComponent };